<template>
  <div>
    <div class="main-content">
      <div id="boxloading"></div>
      <div class="main-content-inner">
        <div class="breadcrumbs ace-save-state" id="breadcrumbs">
          <ul class="breadcrumb">
            <li>
              <i class="ace-icon fa fa-home home-icon"></i>
              <a href="#/">ダッシュボード</a>
            </li>
            <router-link tag="li" :to="{ name: 'user'}">
              <a>ユーザー</a>
            </router-link>
            <li class="active">新規ユーザー登録</li>
          </ul><!-- /.breadcrumb -->
        </div>
        <div class="page-header">
          <div class="checkbox">
            <h3>新規ユーザー登録</h3>
          </div>
        </div><!-- /.page-header -->
        <div class="page-content register_user">
          <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
          <div class="tab-content">
            <div class="alert alert-success" v-if="message_success">
              {{ message_success }}
            </div>
            <div class="alert alert-danger" v-if="message_error">
              {{ message_error }}
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-2 center userav">
                <span class="profile-picture">
                  <img id="user_avatar" class="editable img-responsive" alt="user avatar" src="../../../static/images/avatars/default-avatar.png" width="150" height="150" style="width:150px" />
                </span>
                <label for="file_user_avatar" class="btn-upload" style="background:black;color:white;padding:5px 15px;margin-top:10px;cursor: pointer;">
                  画像ファイルを選択
                  <input type="file" name="avatar" style="display:none" id="file_user_avatar" accept='image/png'>
                </label>
                <span id="fileimg_error" class="error_m"></span>
              </div><!-- /.col -->
              <div class="col-xs-12 col-sm-10">
                <div class="profile-user-info">
                  <div class="profile-info-row">
                    <div class="profile-info-name">ユーザーID</div>
                    <div class="profile-info-value">
                      <span id="userid_error" class="error_m"></span>
                      <input placeholder="ユーザーID" id="userid" type="text" name="userId" class="form-control input-sm" v-model="userInfor.userId">
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">ログインパスワード</div>
                    <label class="clearfix cusrow">
                      <span id="password_error" class="error_m"></span>
                      <input id="password" placeholder="パスワード" name="password" type="password" class="form-control input-sm" v-model="userInfor.password">
                    </label>
                    <span class="newpassword-showhide">
                      <span class="show-password" @click="showhidePassword('password' , 'show-password' , 'newpassword-showhide')"><img src="../../../static/img/eye_off.png" width="30"></span>
                      <span class="hide-password" @click="showhidePassword('password' , 'hide-password' , 'newpassword-showhide')"><img src="../../../static/img/eye_on.png" width="30"></span>
                    </span>
                    <div class="warringu">
                      ログインパスワードは英大文字、英小文字、数字を組み合わせた8文字以上64文字以内で入力してください。
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">ユーザー名（登録名）</div>
                    <div class="profile-info-value">
                      <span id="name_error" class="error_m"></span>
                      <input type="text" class="form-control input-sm" id="name" placeholder="ユーザー名" v-model="userInfor.name">
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">ユーザー名（ふりがな）</div>
                    <div class="profile-info-value">
                      <span id="furigana_error" class="error_m"></span>
                      <input type="text" class="form-control input-sm" id="furigana" placeholder="ふりがな" v-model="userInfor.furigana">
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">メールアドレス</div>
                    <div class="profile-info-value">
                      <span id="mailaddress_error" class="error_m"></span>
                      <input type="text" class="form-control input-sm" id="mailaddress" placeholder="example@example.com" v-model="userInfor.email">
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">暗証番号</div>
                    <div class="profile-info-value">
                      <span id="passcode_error" class="error_m"></span>
                      <input type="text" class="form-control input-sm" id="passcode" placeholder="0000" v-model="userInfor.passCode">
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">組織管理権限</div>
                    <div class="profile-info-value">
                      <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="userInfor.isAdmin">
                      <span class="lbl"></span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">ゲート設定権限</div>
                    <div class="profile-info-value">
                      <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="userInfor.isPhoneAdmin">
                      <span class="lbl"></span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">鍵共有権限</div>
                    <div class="profile-info-value">
                      <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="userInfor.shareKeyBeValid">
                      <span class="lbl"></span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">ステータス</div>
                    <div class="profile-info-value">
                      <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="userInfor.isValid">
                      <span class="lbl"></span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">備考.1</div>
                    <div class="profile-info-value">
                      <span id="option1_error" class="error_m"></span>
                      <textarea class="form-control" id="option1" placeholder="備考.1" v-model="userInfor.option1"></textarea>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">備考.2</div>
                    <div class="profile-info-value">
                      <span id="option2_error" class="error_m"></span>
                      <textarea class="form-control" id="option2" placeholder="備考.2" v-model="userInfor.option2"></textarea>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12">
                    <div class="action_box">
                      <router-link :to="{ name: 'user'}" class="btn cancel_bottom">
                        キャンセル
                      </router-link>
                      <button class="btn btn-info save_bottom" type="button" @click="validateBeforeSubmit">
                        ユーザーを登録
                      </button>
                    </div>
                  </div>
                </div>
              </div><!-- /.col -->
            </div>
          </div>
        </div><!-- /.page-content -->
      </div>
    </div><!-- /.main-content -->
  </div>
</template>

<script>
import * as Config from '../../config'

export default {
  data () {
    return {
      userInfor: {
        userId: '',
        password: '',
        name: '',
        furigana: '',
        email: '',
        thumbnail: '',
        passCode: '',
        isAdmin: false,
        isPhoneAdmin: false,
        shareKeyBeValid: false,
        isValid: true,
        option1: '',
        option2: ''
      },
      loading: false,
      flag: 0,
      flagU: false,
      flagP: false,
      base64: '',
      sucessStatus: false,
      error: '',
      message_success: '',
      message_error: '',
      imgWidth: 0,
      imgHeight: 0
    }
  },
  mounted () {
    var vm = this
    $('input:file').change(function () {
      var file = document.querySelector('input[type="file"]').files[0]
      vm.getBase64(file)
      vm.converImgtpBase64(file)
    })
    var _URL = window.URL
    $('#file_user_avatar').change(function (e) {
      var file, img
      if ((file = this.files[0])) {
        img = new Image()
        img.onload = function () {
          vm.imgWidth = this.width
          vm.imgHeight = this.height
        }
        img.src = _URL.createObjectURL(file)
      }
    })
  },
  methods: {
    showhidePassword (passwordId, classname, buttonname) {
      if (classname === 'show-password') {
        $('#' + passwordId).attr('type', 'text')
        $('.' + buttonname).find('.show-password').hide()
        $('.' + buttonname).find('.hide-password').show()
      } else {
        $('#' + passwordId).attr('type', 'password')
        $('.' + buttonname).find('.hide-password').hide()
        $('.' + buttonname).find('.show-password').show()
      }
    },
    getBase64 (file) {
      var reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = function () {
        document.getElementById('user_avatar').setAttribute(
          'src', reader.result
        )
      }
      reader.onerror = function (error) {
        console.log('Error: ', error)
      }
    },
    converImgtpBase64 (file) {
      var vm = this
      var reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = function () {
        var str = reader.result
        var imgurl = str.replace(/^data:image\/[a-z]+;base64,/, '')
        vm.userInfor.thumbnail = imgurl
      }
    },
    reset () {
      this.userInfor.userId = null
      this.userInfor.password = null
      this.userInfor.name = null
      this.userInfor.furigana = null
      this.userInfor.email = null
      this.userInfor.passCode = '0000'
      this.userInfor.isAdmin = false
      this.userInfor.isPhoneAdmin = false
      this.userInfor.shareKeyBeValid = false
      this.userInfor.isValid = true
      this.userInfor.option1 = null
      this.userInfor.option2 = null
    },
    validateBeforeSubmit () {
      this.flag = 0
      this.flagU = true
      this.flagP = true
      var englishUserid = /^[A-Za-z0-9@.-_]*$/
      if (this.userInfor.userId === null || this.userInfor.userId === '') {
        $('#userid_error').html('ユーザーIDは必須です。')
        $('#userid').addClass('error')
        this.flagU = false
      } else if (this.userInfor.userId.length < 4 || this.userInfor.userId.length > 96 || !englishUserid.test(this.userInfor.userId)) {
        $('#userid_error').html('ユーザーIDは半角英数字4文字以上96文字以内で入力してください。')
        $('#userid').addClass('error')
        this.flagU = false
      } else {
        $('#userid_error').html('')
        $('#userid').removeClass('error')
        this.flagU = true
      }
      var englishPassword = /^[A-Za-z0-9@]*$/
      if (this.userInfor.password === null || this.userInfor.password === '') {
        $('#password_error').html('パスワードは必須です。')
        $('#password').addClass('error')
        this.flagP = false
      } else if (!this.userInfor.password.match('^(?=.*[a-z])(?=.*[A-Z])(?=.*).{8,64}$') || !englishPassword.test(this.userInfor.password)) {
        $('#password_error').html('ログインパスワードは英大文字、英小文字、数字を組み合わせた8文字以上64文字以内で入力してください。')
        $('#password').addClass('error')
        this.flagP = false
      } else {
        $('#password_error').html('')
        $('#password').removeClass('error')
        this.flagP = true
      }
      if (this.userInfor.name !== null && this.userInfor.name !== '') {
        if (this.userInfor.name.length > 64) {
          $('#name_error').html('ユーザー名は64文字以内で入力してください。')
          $('#name').addClass('error')
          this.flag += 1
        } else {
          $('#name_error').html('')
          $('#name').removeClass('error')
        }
      }
      if (this.userInfor.furigana !== null && this.userInfor.furigana !== '') {
        if (!this.userInfor.furigana.match(/^[ぁ-んー一\r\n\t]+$/)) {
          $('#furigana_error').html('ふりがなは全角ひらがなで入力してください。')
          $('#furigana').addClass('error')
          this.flag += 1
        } else {
          if (this.userInfor.furigana.length > 64) {
            $('#furigana_error').html('ふりがなは64文字以内で入力してください。')
            $('#furigana').addClass('error')
            this.flag += 1
          } else {
            $('#furigana_error').html('')
            $('#furigana').removeClass('error')
          }
        }
      }
      if (this.userInfor.email !== null && this.userInfor.email !== '') {
        if (!this.userInfor.email.match(/^([a-zA-Z0-9])+([a-zA-Z0-9._-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9._-]+)+$/)) {
          $('#mailaddress_error').html('正しいメールアドレスを入力してください。')
          $('#mailaddress').addClass('error')
          this.flag += 1
        } else {
          $('#mailaddress_error').html('')
          $('#mailaddress').removeClass('error')
        }
      }
      if (this.userInfor.passCode !== null && this.userInfor.passCode !== '') {
        if (!this.userInfor.passCode.match(/^\d{4}$/)) {
          $('#passcode_error').html('暗証番号は数字4文字で入力してください。')
          $('#passcode').addClass('error')
          this.flag += 1
        } else {
          $('#passcode_error').html('')
          $('#passcode').removeClass('error')
        }
      }
      if (this.userInfor.option1 !== null && this.userInfor.option1 !== '') {
        if (this.userInfor.option1.length > 64) {
          $('#option1_error').html('備考.1は64文字以内で入力してください。')
          $('#option1').addClass('error')
          this.flag += 1
        } else {
          $('#option1_error').html('')
          $('#option1').removeClass('error')
        }
      }
      if (this.userInfor.option2 !== null && this.userInfor.option2 !== '') {
        if (this.userInfor.option2.length > 64) {
          $('#option2_error').html('備考.2は64文字以内で入力してください。')
          $('#option2').addClass('error')
          this.flag += 1
        } else {
          $('#option2_error').html('')
          $('#option2').removeClass('error')
        }
      }
      if (this.userInfor.thumbnail !== null && this.userInfor.thumbnail !== '') {
        var fileimg = document.querySelector('input[type="file"]').files[0]
        if (this.imgWidth > 150 || this.imgHeight > 150) {
          this.message = '登録できる画像は、「ファイル形式：png、縦150×横150、ファイルサイズは64kバイト」となります。'
          $('#error-alert').fadeTo(2000, 500).slideUp(500, function () {
            $('#error-alert').slideUp(500)
          })
          this.flag += 1
        }
        if (fileimg.type !== 'image/png') {
          this.message = '登録できる画像は、「ファイル形式：png、縦150×横150、ファイルサイズは64kバイト」となります。'
          $('#error-alert').fadeTo(2000, 500).slideUp(500, function () {
            $('#error-alert').slideUp(500)
          })
          this.flag += 1
        }
        if (fileimg.size > 65536) {
          this.message = '登録できる画像は、「ファイル形式：png、縦150×横150、ファイルサイズは64kバイト」となります。'
          $('#error-alert').fadeTo(2000, 500).slideUp(500, function () {
            $('#error-alert').slideUp(500)
          })
          this.flag += 1
        }
      }
      if (this.flag === 0 && this.flagU && this.flagP) {
        this.loading = true
        this.addUser()
      }
    },
    addUser () {
      this.message = ''
      this.message_error = ''
      var OuserInfor = {
        userId: this.userInfor.userId,
        password: this.userInfor.password
      }
      if (this.userInfor.name !== null && this.userInfor.name !== '') {
        OuserInfor.name = this.userInfor.name
      }
      if (this.userInfor.furigana !== null && this.userInfor.furigana !== '') {
        OuserInfor.furigana = this.userInfor.furigana
      }
      if (this.userInfor.email !== null && this.userInfor.email !== '') {
        OuserInfor.email = this.userInfor.email
      }
      if (this.userInfor.thumbnail !== null && this.userInfor.thumbnail !== '') {
        OuserInfor.thumbnail = this.userInfor.thumbnail
      }
      if (this.userInfor.passCode !== null && this.userInfor.passCode !== '') {
        OuserInfor.passCode = this.userInfor.passCode
      }
      if (this.userInfor.isAdmin !== null && this.userInfor.isAdmin !== '') {
        OuserInfor.isAdmin = this.userInfor.isAdmin
      }
      if (this.userInfor.isPhoneAdmin !== null && this.userInfor.isPhoneAdmin !== '') {
        OuserInfor.isPhoneAdmin = this.userInfor.isPhoneAdmin
      }
      if (this.userInfor.shareKeyBeValid !== null && this.userInfor.shareKeyBeValid !== '') {
        OuserInfor.shareKeyBeValid = this.userInfor.shareKeyBeValid
      }
      if (this.userInfor.isValid !== null && this.userInfor.isValid !== '') {
        OuserInfor.isValid = this.userInfor.isValid
      }
      if (this.userInfor.option1 !== null && this.userInfor.option1 !== '') {
        OuserInfor.option1 = this.userInfor.option1
      }
      if (this.userInfor.option2 !== null && this.userInfor.option2 !== '') {
        OuserInfor.option2 = this.userInfor.option2
      }
      console.log(JSON.stringify(OuserInfor))
      this.$http.post(Config.USERS_LIST_API, JSON.stringify(OuserInfor))
        .then(response => {
          this.loading = false
          console.log(response)
          if (response.body.message === 'Success') {
            this.sucessStatus = true
            this.reset()
            this.message_success = Config.ADD_USER_API_SUCCESS
            this.message_error = ''
          } else {
            this.loading = false
            this.error = true
            this.message_success = ''
            this.message_error = Config.ADD_USER_API_ERROR
          }
        })
        .catch((error) => {
          this.loading = false
          this.message_success = ''
          switch (error.status) {
            case 400:
              this.message_error = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.message_error = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
            case 409:
              this.message_error = '入力されたユーザーIDは既に使用されています。他のユーザーIDを入力してください。'
              break
            case 500:
              this.message_error = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.message_error = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.message_error = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
          }
        })
    }
  }
}
</script>

<style type="text/css">
.warringu{
  padding-left:5px;
}
#error-alert, #success-alert {
  display: none;
}
textarea.error {
  border:1px solid red;
}
span.error_m {
  font-size: 15px;
  font-weight: normal;
  color: #FF4040;
  display: block;
  margin: 0;
}
.cusrow{
  padding: 6px 4px 6px 6px;
  width: 95%;
  margin-right: 10px;
  border-top: 1px dotted #D5E4F1;
}
  input[type=checkbox].ace.ace-switch+.lbl::before{
    text-indent: 25px!important;
    content: "無効"!important;
  }
  input[type=checkbox].ace.ace-switch:checked+.lbl::before{
    text-indent: 5px!important;
    content: "有効"!important;
  }
  .register_user .profile-info-name{
    text-align: left;
    width: 225px
  }
  .userav input[type=file] {
    margin: 0 auto
  }
  span.error {
  color: red;
}
input.error {
  border: 1px solid red;
}
</style>



// WEBPACK FOOTER //
// src/views/user/UserAdd.vue